// ✅ redux/states/categories/slice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  AllCategoryThunk,
  GetSingleCategoryThunk,
  AddCategoryThunk,
  UpdateCategoryThunk,
  DeleteCategoryThunk,
  AllSubCategoryThunk,
  GetSingleSubCategoryThunk,
  AddSubCategoryThunk,
  UpdateSubCategoryThunk,
  DeleteSubCategoryThunk,
} from "./thunk";

const initialState = {
  categories: [],
  singleCategory: null,
  subcategories: [],
  subsingleCategory: null,
  loading: false,
  error: null,
  successMessage: null,
};

const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    clearCategoryState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* -------------------- GET ALL -------------------- */
      .addCase(AllCategoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload?.data || [];
      })
      .addCase(AllCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- GET SINGLE -------------------- */
      .addCase(GetSingleCategoryThunk.fulfilled, (state, action) => {
        state.singleCategory = action.payload?.data || null;
      })

      /* -------------------- ADD -------------------- */
      .addCase(AddCategoryThunk.fulfilled, (state, action) => {
        state.successMessage = "Category added successfully!";
      })

      /* -------------------- UPDATE -------------------- */
      .addCase(UpdateCategoryThunk.fulfilled, (state, action) => {
        state.successMessage = "Category updated successfully!";
      })

      /* -------------------- DELETE -------------------- */
      .addCase(DeleteCategoryThunk.fulfilled, (state, action) => {
        state.categories = state.categories.filter(
          (c) => c.uuid !== action.payload.uuid
        );
        state.successMessage = "Category deleted successfully!";
      })

      /* -------------------- GET ALL SUB CATEGORY-------------------- */

      /* -------------------- GET ALL -------------------- */
      .addCase(AllSubCategoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllSubCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.subcategories = action.payload?.data || [];
      })
      .addCase(AllSubCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- GET SINGLE -------------------- */
      .addCase(GetSingleSubCategoryThunk.fulfilled, (state, action) => {
        state.subsingleCategory = action.payload?.data || null;
      })

      /* -------------------- ADD -------------------- */
      .addCase(AddSubCategoryThunk.fulfilled, (state, action) => {
        state.successMessage = "Category added successfully!";
      })

      /* -------------------- UPDATE -------------------- */
      .addCase(UpdateSubCategoryThunk.fulfilled, (state, action) => {
        state.successMessage = "Category updated successfully!";
      })

      /* -------------------- DELETE -------------------- */
      .addCase(DeleteSubCategoryThunk.fulfilled, (state, action) => {
        state.subcategories = state.subcategories.filter(
          (c) => c.uuid !== action.payload.uuid
        );
        state.successMessage = "Category deleted successfully!";
      });
  },
});

export const { clearCategoryState } = categorySlice.actions;
export default categorySlice.reducer;
